import { gql, useMutation } from "@apollo/client";

const UPDATE_BEFORE_AND_AFTER = gql`
  mutation UpdateBeforeAndAfterProject(
    $_id: ID!
    $designerId: ID
    $name: String
    $description: String
    $style: ProjectStyles
    $projectCategory: ProjectCategory
    $specialRequirements: [SpecialRequirements]
    $budgetRange: BudgetRange
    $squareFootage: SquareFootage
    $projectDuration: ProjectDuration
    $beforeImage: ID
    $afterImage: ID
    $coverImage: ID
    $displayOrder: Int
    $featuredOnBio: Boolean
    $published: Boolean
    $storyTitle: String
    $storySubtitle: String
    $introduction: String
    $challenges: String
    $wishList: [String]
    $overview: String
    $additionalSections: [AdditionalSectionInput]
    $beforeImages: [ID]
    $afterImages: [ID]
  ) {
    updateBeforeAndAfterProject(
      _id: $_id
      designerId: $designerId
      name: $name
      description: $description
      style: $style
      projectCategory: $projectCategory
      specialRequirements: $specialRequirements
      budgetRange: $budgetRange
      squareFootage: $squareFootage
      projectDuration: $projectDuration
      beforeImage: $beforeImage
      afterImage: $afterImage
      coverImage: $coverImage
      displayOrder: $displayOrder
      featuredOnBio: $featuredOnBio
      published: $published
      storyTitle: $storyTitle
      storySubtitle: $storySubtitle
      introduction: $introduction
      challenges: $challenges
      wishList: $wishList
      overview: $overview
      additionalSections: $additionalSections
      beforeImages: $beforeImages
      afterImages: $afterImages
    ) {
      _id
      designerId
      name
      description
      style
      projectCategory
      specialRequirements
      budgetRange
      squareFootage
      projectDuration
      beforeImage
      afterImage
      coverImage
      displayOrder
      featuredOnBio
      published
      storyTitle
      storySubtitle
      introduction
      challenges
      wishList
      overview
      additionalSections {
        title
        content
      }
      beforeImages
      afterImages
    }
  }
`;

export const useUpdateBeforeAndAfterMutation = () => {
  const [updateBeforeAndAfterMutation, { loading, error, data }] = useMutation(
    UPDATE_BEFORE_AND_AFTER
  );

  const updateBeforeAndAfter = async (args: any) => {
    try {
      const { data } = await updateBeforeAndAfterMutation({
        variables: args,
      });
      return data?.updateBeforeAndAfterProject;
    } catch (error) {
      console.error("Error updating before and after project:", error);
      throw error;
    }
  };

  return { updateBeforeAndAfter, loading, error, data };
};
